"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {},
  data: function data() {
    return {
      id: this.$route.params.id || '',
      form: {
        check_user_right: 1,
        free_order_switch: 1
      }
    };
  },
  computed: {
    agentInfo: function agentInfo() {
      return this.$store.getters.agentInfo;
    }
  },
  mounted: function mounted() {
    this.getInfo();
  },
  methods: {
    /**
     * 获取商户信息
     */
    getInfo: function getInfo() {
      var _this = this;
      var params = {};
      if (this.id > 0) params.store_id = this.id;
      this.$get('agentapi/store/wxgzh_config', params).then(function (res) {
        res = res.id ? res : {};
        res.encryption_method = res.encryption_method || 'text';
        res.follow_open = res.follow_open || 0;
        _this.form = res;
      });
    },
    onSubmit: function onSubmit() {
      var _this2 = this;
      var url = 'agentapi/store/wxgzh_config';
      var params = JSON.parse(JSON.stringify(this.form));
      params.store_id = this.id;
      this.$post(url, params).then(function (res) {
        _this2.$message({
          message: '提交成功',
          type: 'success'
        });
        if (_this2.checkRoles(['terminal'])) {
          _this2.$router.push({
            path: '/wx/wxpublic'
          });
        }
      });
    }
  }
};